<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Empleados Van Offline</v-toolbar-title>
          <v-spacer></v-spacer>
          <sbtn text="Nuevo usuario" :onClick="newUser" icon="mdi-plus" colorBtn="white" typeButton="text" :load="loading" :disabled="(clientSearch !== '' ? false : true) || !isWriting" />
          <v-btn :disabled="items == 0" elevation="0" text small :loading="loading">
            <xlsx-workbook>
              <xlsx-sheet :collection="sheet.data" v-for="sheet in sheetsGeneral" :key="sheet.name" :sheet-name="sheet.name" />
              <xlsx-download :filename="'Reporte ' + this.reportTypeGeneral + '.xlsx'">
                <button>DESCARGAR</button>
                <v-icon right>mdi-microsoft-excel</v-icon>
              </xlsx-download>
            </xlsx-workbook>
          </v-btn>
        </v-toolbar>
        <v-card-title style="display: flex; align-items: flex-end;">
          <v-text-field class="ml-5 mt-0" v-model="search" label="Buscar" single-line hide-details clearable></v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="clientSearch"
            :items="clientItem"
            item-text="nombre_comercial"
            item-value="idcliente_externo"
            label="Clientes"
            hide-details
            prepend-icon="mdi-account-group"
            @change="refresh()"
          ></v-autocomplete>
          <v-btn :disabled="!isReading" small center outlined color="blueKonect" class="mx-2" elevation="0" @click="updateData()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            loading-text="Cargando registros... Porfavor espere"
            :search="search"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              itemsPerPageAllText: 'Todos',
            }"
          >
            <template v-slot:[`item.numero_nomina`]="{ item }">
              <span v-text="item.numero_nomina" />
            </template>
            <template v-slot:[`item.estado`]="{ item }">
              <infoChip
                :text="item.detalle.detalle_usuario_offline.estado ? 'Activo' : 'Inactivo'"
                :color="item.detalle.detalle_usuario_offline.estado ? 'success' : 'error'"
                :iconName="item.detalle.detalle_usuario_offline.estado ? 'mdi-account' : 'mdi-account'"
                rightIcon
              />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div style="display: flex; justify-content: space-around">
                <infoBtn :icon="'mdi-qrcode-scan'" :text="'Códigos QR'" :actionColor="'blueKonect'" :data="item" :onClick="openQR" :permission="!isReading || loading" />
                <infoBtn
                  :icon="item.detalle.detalle_usuario_offline.estado ? 'mdi-close-thick' : 'mdi-check'"
                  :text="item.detalle.detalle_usuario_offline.estado ? 'Desactivar' : 'Activar'"
                  :actionColor="item.detalle.detalle_usuario_offline.estado ? 'error' : 'success'"
                  :data="item"
                  :onClick="openDeactivate"
                  :permission="!isRemoving || loading"
                />
                <infoBtn :icon="'mdi-pencil'" :text="'Editar'" :actionColor="'blueKonect'" :data="item" :onClick="openUpdate" :permission="!isRemoving || loading" />
              </div>
            </template>
            <template v-slot:[`footer.page-text`]="props">
              Página {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-data> No hay información disponible </template>
            <template v-slot:no-results> No se obtuvieron resultados </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogs.new" persistent scrollable max-width="1200px">
        <v-card class="rounded-xl elevation-16">
          <v-toolbar dense dark color="blueKonect" elevation="2">
            <v-toolbar-title>Nuevo usuario</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="!isWriting || loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" v-on:submit.prevent lazy-validation>
                <v-row>
                  <v-col cols="6">
                    <v-text-field prepend-icon="mdi-account" v-model="forms.new.nombre" label="Nombre" :rules="[rules.required]" :disabled="loading" maxlength="50" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      prepend-icon="mdi-alpha-p"
                      v-model="forms.new.apellido_paterno"
                      label="Apellido paterno"
                      :rules="[rules.required]"
                      :disabled="loading"
                      maxlength="50"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      prepend-icon="mdi-alpha-m"
                      v-model="forms.new.apellido_materno"
                      label="Apellido materno"
                      :rules="[rules.required]"
                      :disabled="loading"
                      maxlength="50"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      prepend-icon="mdi-credit-card-outline"
                      v-model="forms.new.detalle.numero_nomina"
                      label="Número de nómina"
                      :rules="[rules.required]"
                      :disabled="loading"
                      maxlength="20"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-switch v-model="forms.new.detalle.detalle_usuario_offline.estado" label="Estado" color="success" hide-details></v-switch>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      prepend-icon="mdi-account-convert"
                      v-model="forms.new.detalle.detalle_usuario_offline.idcliente_externo"
                      :items="clientItem"
                      :rules="[rules.required]"
                      label="Cliente"
                      item-text="nombre_comercial"
                      item-value="idcliente_externo"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogs.update" persistent scrollable max-width="1200px">
        <v-card class="rounded-xl elevation-16">
          <v-toolbar dense dark color="blueKonect" elevation="2">
            <v-toolbar-title>Editar usuario</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="!isWriting || loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formDetail" v-on:submit.prevent lazy-validation>
                <v-row>
                  <v-col cols="6">
                    <v-text-field prepend-icon="mdi-account" v-model="forms.update.nombre" label="Nombre" :rules="[rules.required]" :disabled="loading" maxlength="50" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      prepend-icon="mdi-alpha-p"
                      v-model="forms.update.apellido_paterno"
                      label="Apellido paterno"
                      :rules="[rules.required]"
                      :disabled="loading"
                      maxlength="50"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      prepend-icon="mdi-alpha-m"
                      v-model="forms.update.apellido_materno"
                      label="Apellido materno"
                      :rules="[rules.required]"
                      :disabled="loading"
                      maxlength="50"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      prepend-icon="mdi-credit-card-outline"
                      v-model="forms.update.detalle.numero_nomina"
                      label="Número de nómina"
                      :rules="[rules.required]"
                      :disabled="loading"
                      maxlength="20"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      prepend-icon="mdi-account-convert"
                      v-model="forms.update.detalle.detalle_usuario_offline.idcliente_externo"
                      :items="clientItem"
                      :rules="[rules.required]"
                      label="Cliente"
                      item-text="nombre_comercial"
                      item-value="idcliente_externo"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div v-if="forms.deactivate.length > 0">
        <simpleDialog
          :active="dialogs.deactivate"
          :clickRemove="deactivate"
          :clickCancel="cancel"
          :btnColor="forms.deactivate[0].detalle.detalle_usuario_offline.estado ? 'green' : 'red'"
          :removeMsg="forms.deactivate[0].detalle.detalle_usuario_offline.estado ? '¿Esta seguro que deseas activar al usuario?' : '¿Esta seguro que deseas desactivar al usuario?'"
          :title="forms.deactivate[0].detalle.detalle_usuario_offline.estado ? 'Activar Usuario' : 'Desactivar Usuario'"
          :btnMsgRemove="forms.deactivate[0].detalle.detalle_usuario_offline.estado ? 'Activar' : 'Desactivar'"
        />
      </div>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ msgError }}
        {{ "\n\n" + this.codeError }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { tablek, errormsg, simpleDialog, infoBtn, csvButton, sbtn, infoChip } from "@/components";
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";
import errorList from "@/utils/errorsList";
import { mapActions } from "vuex";

export default {
  name: "Clientes",
  components: {
    tablek,
    errormsg,
    simpleDialog,
    csvButton,
    sbtn,
    infoBtn,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    infoChip,
  },
  data: () => ({
    loading: false,
    loadingUpload: false,
    success: false,
    msgSuccess: "",
    errorList,
    codeError: "",
    msgError: "",
    code: "",
    itemDelete: "",
    error: false,
    reportTypeGeneral: "",
    sheetsGeneral: [],
    fileInfo: undefined,
    search: "",
    saveUpload: undefined,
    msgRemove: "¿Está seguro que desea desactivar al usuario?",
    headers: [
      { text: "Número de nómina", align: "center", value: "numero_nomina", sortable: true },
      { text: "Nombre de empleado", align: "center", value: "nombre", sortable: true },
      { text: "Apellido paterno", align: "center", value: "apellido_paterno", sortable: true },
      { text: "Apelido materno", align: "center", value: "apellido_materno", sortable: true },
      { text: "Estado", align: "center", value: "estado", sortable: true },
      { text: "Acciones", align: "center", value: "actions", sortable: false },
    ],
    items: [],
    itemsCSV: [],
    employeeRoutes: [],
    clientItem: [],
    clientSearch: "",
    dialogs: {
      new: false,
      update: false,
      deactivate: false,
    },
    forms: {
      new: {
        idusuario_externo: undefined,
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        detalle: {
          idusuario_externo: undefined,
          numero_nomina: "",
          detalle_usuario_offline: {
            estado: true,
            idcliente_externo: "",
          },
        },
      },
      update: {
        idusuario_externo: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        detalle: {
          idusuario_externo: "",
          numero_nomina: "",
          detalle_usuario_offline: {
            iddetalle_usuarios_offline_externo: "",
            estado: true,
            idcliente_externo: "",
          },
        },
      },
      deactivate: {
        idusuario_externo: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        detalle: {
          idusuario_externo: "",
          numero_nomina: "",
          detalle_usuario_offline: {
            iddetalle_usuarios_offline_externo: "",
            estado: true,
            idcliente_externo: "",
          },
        },
      },
    },
    rules: {
      required: (v) => !!v || "El campo es obligatorio",
      max13: (v) => (v || "").length <= 13 || "Limite de caracteres",
      max200: (v) => (v || "").length <= 200 || "Limite de caracteres",
      number: (v) => {
        if (!!v && v !== "") {
          return /^[0-9]+$/.test(v) || "Número inválido";
        } else {
          return true;
        }
      },
      email: (v) => {
        if (v !== "") {
          return /.+@.+\..+/.test(v) || "Correo inválido";
        } else {
          return true;
        }
      },
    },
  }),
  mounted() {
    if (this.isReading) {
      this.getClients();
    }
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    isWriting: function () {
      return services.check(2, this.$route.path);
    },
    isRemoving: function () {
      return services.check(3, this.$route.path);
    },
  },
  methods: {
    ...mapActions("vanOffline", ["setComponent"]),
    updateData() {
      this.refresh();
    },
    async refresh() {
      try {
        this.loading = true;
        const response = await this.axios.get(services.routes.vanOffline);
        this.items = response.data.data.filter((item) => item.detalle.detalle_usuario_offline.idcliente_externo === this.clientSearch);

        for (let i = 0; i < this.items.length; i++) {
          this.items[i].numero_nomina = this.items[i].detalle.numero_nomina;
          this.items[i].estado = this.items[i].detalle.detalle_usuario_offline.estado ? "Activo" : "Inactivo";
        }
        this.reportTypeGeneral = "Empleados Van Offline";
        this.sheetsGeneral = [
          {
            name: "Empleados Van Offline",
            data: [{}],
          },
        ];
        if (this.items.length > 0) {
          this.sheetsGeneral[0].data.shift();
        }
        for (let i = 0; i < this.items.length; i++) {
          let obj = {
            "Número de nómina": this.items[i].numero_nomina ? this.items[i].numero_nomina : "",
            "Nombre de empleado": this.items[i].nombre ? this.items[i].nombre : "",
            "Apellido Paterno": this.items[i].apellido_paterno ? this.items[i].apellido_paterno : "",
            "Apellido Materno": this.items[i].apellido_materno ? this.items[i].apellido_materno : "",
            Estado: this.items[i].estado ? this.items[i].estado : "",
          };
          this.sheetsGeneral[0].data.push(obj);
        }
      } catch (error) {
        this.error = true;
        this.msgError = error.response?.data?.message || "Hubo un error.";
        this.codeError = error.response?.data?.code || "GENERAL_ERROR";
      } finally {
        this.loading = false;
      }
    },
    async getClients() {
      try {
        this.loading = true;
        this.clientItem = [];
        const response = await services.ws("get", "clients");
        this.clientItem = response.data;
        if (this.clientItem && this.clientItem.length > 0) {
          this.clientSearch = this.clientItem[0].idcliente_externo;
        }
        this.refresh();
      } catch (error) {
        this.error = true;
        this.msgError = error.response?.data?.message || "Hubo un error.";
        this.codeError = error.response?.data?.code || "GENERAL_ERROR";
      }
    },
    newUser() {
      this.dialogs.new = true;
      this.forms.new.detalle.detalle_usuario_offline.estado = true
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true;
        let data = [this.forms.new];

        this.axios
          .post(services.routes.vanOffline + "/upsert", { data })
          .then((res) => {
            this.cancel();
            this.refresh();
            this.success = true;
            this.msgSuccess = "Usuario creado correctamente";
          })
          .catch((error) => {
            this.error = true;
            this.msgError = error.response.data.message;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "La solicitud tiene información no válida.";
        this.codeError = "INVALID_DATA";
      }
    },
    cancel() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset();
      }
      if (this.$refs.formDetail) {
        this.$refs.formDetail.resetValidation();
      }
      this.dialogs.new = false;
      this.dialogs.update = false;
      this.dialogs.deactivate = false;
    },
    openDeactivate(item) {
      this.forms.deactivate = JSON.parse(JSON.stringify([item]));
      this.forms.deactivate[0].detalle.detalle_usuario_offline.estado = !item.detalle.detalle_usuario_offline.estado;
      this.dialogs.deactivate = true;
    },
    deactivate() {
      this.loading = true;
      let data = this.forms.deactivate;
      this.axios
        .post(services.routes.vanOffline + "/upsert", { data })
        .then((res) => {
          this.cancel();
          this.refresh();
          this.success = true;
          this.msgSuccess = "Usuario actualizado correctamente";
        })
        .catch((error) => {
          this.error = true;
          this.msgError = error.response.data.message;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openUpdate(data) {
      this.forms.update = JSON.parse(JSON.stringify(data));
      this.dialogs.update = true;
    },
    update() {
      if (this.$refs.formDetail.validate()) {
        this.loading = true;
        let data = [this.forms.update];
        this.axios
          .post(services.routes.vanOffline + "/upsert", { data })
          .then((res) => {
            this.cancel();
            this.refresh();
            this.success = true;
            this.msgSuccess = "Usuario actualizado correctamente";
          })
          .catch((error) => {
            this.error = true;
            this.msgError = error.response.data.message;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "La solicitud tiene información no válida.";
        this.codeError = "INVALID_DATA";
      }
    },
    openQR(item) {
      this.setComponent({ component: "detail", item });
    },
  },
};
</script>

<style scoped></style>
